export function validateEmail(email: string) {
  let error: string | null = null;
  const allowedCharactersRegex = /^[a-zA-Z0-9+_\-~!#$%&'./=^{}|]+@[^\s@]+\.[^\s@]+$/;

  if (email.length > 40) {
    error = "E-mail должен быть менее 40 символов";
  } else if (!allowedCharactersRegex.test(email)) {
    error = "Некорректный формат E-mail";
  }

  return error;
}
